import { AdminSignUpSteps } from "./types";

export const adminSignUpStepsArray = Object.keys(AdminSignUpSteps);
export const ADMIN_SIGN_UP_STEPS_NUMBER = adminSignUpStepsArray.length / 2;
